import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from './store';
import { LoginPage } from './pages/LoginPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { DashboardPage } from './pages/DashboardPage';
import { QuickClientCreatePage } from './pages/QuickClientCreatePage';
import { ClientsListPage } from './pages/ClientsListPage';
import { ClientEditPage } from './pages/ClientEditPage';
import { ClientViewPage } from './pages/ClientViewPage';
import { PractitionersListPage } from './pages/PractitionersListPage';
import { PractitionerCreatePage } from './pages/PractitionerCreatePage';
import { PractitionerEditPage } from './pages/PractitionerEditPage';
import { PractitionerViewPage } from './pages/PractitionerViewPage';
import PractitionerApplicationsPage from './pages/PractitionerApplicationsPage';
import { VendorsListPage } from './pages/VendorsListPage';
import { VendorCreatePage } from './pages/VendorCreatePage';
import { VendorEditPage } from './pages/VendorEditPage';
import { EmployeesListPage } from './pages/EmployeesListPage';
import { EmployeeCreatePage } from './pages/EmployeeCreatePage';
import { EmployeeEditPage } from './pages/EmployeeEditPage';
import { AppointmentsListPage } from './pages/AppointmentsListPage';
import { AppointmentViewPage } from './pages/AppointmentViewPage';
import { AppointmentEditPage } from './pages/AppointmentEditPage';
import { AppointmentCreatePage } from './pages/AppointmentCreatePage';
import { ShopsListPage } from './pages/ShopsListPage';
import { ShopCreatePage } from './pages/ShopCreatePage';
import { ShopEditPage } from './pages/ShopEditPage';
import { ShopViewPage } from './pages/ShopViewPage';
import { ServicesListPage } from './pages/ServicesListPage';
import { ServiceCreatePage } from './pages/ServiceCreatePage';
import { ServiceEditPage } from './pages/ServiceEditPage';
import { ServiceViewPage } from './pages/ServiceViewPage';
import { BodyZonesListPage } from './pages/BodyZonesListPage';
import { PiercingTypesListPage } from './pages/PiercingTypesListPage';
import { ItemCollectionsListPage } from './pages/ItemCollectionsListPage';
import { ItemCollectionAssociationsPage } from './pages/ItemCollectionAssociationsPage';
import { ComprehensiveClientCreatePage } from './pages/ComprehensiveClientCreatePage';
import { AnonymousClientCreatePage } from './pages/AnonymousClientCreatePage';
import { PlanningCalendarPage } from './pages/PlanningCalendarPage';
import { CalendarEventsPage } from './pages/CalendarEventsPage';
import { ScheduleRulesPage } from './pages/ScheduleRulesPage';
import { TimeOffManagerPage } from './pages/TimeOffManagerPage';
import { AuditLogsPage } from './pages/AuditLogsPage';
import { CompaniesListPage } from './pages/CompaniesListPage';
import { CompanyCreatePage } from './pages/CompanyCreatePage';
import { CompanyEditPage } from './pages/CompanyEditPage';
import { CompanyViewPage } from './pages/CompanyViewPage';
import AdminsListPage from './pages/AdminsListPage';
import AdminCreatePage from './pages/AdminCreatePage';
import AdminEditPage from './pages/AdminEditPage';
import { UsersListPage } from './pages/UsersListPage';
import { UserViewPage } from './pages/UserViewPage';
import { UserCreatePage } from './pages/UserCreatePage';
import { UserEditPage } from './pages/UserEditPage';
import { PreferencesPage } from './pages/PreferencesPage';
import { GeneralParametersPage } from './pages/GeneralParametersPage';
import { ProfilePage } from './pages/ProfilePage';
import { PasswordPage } from './pages/PasswordPage';
import { ActivityTypesListPage } from './pages/ActivityTypesListPage';
import { ActivityTypeCreatePage } from './pages/ActivityTypeCreatePage';
import { ActivityTypeEditPage } from './pages/ActivityTypeEditPage';
import { EmployeeActivityTypesListPage } from './pages/EmployeeActivityTypesListPage';
import { EmployeeActivityTypeCreatePage } from './pages/EmployeeActivityTypeCreatePage';
import { EmployeeActivityTypeEditPage } from './pages/EmployeeActivityTypeEditPage';
import { ActivitiesListPage } from './pages/ActivitiesListPage';
import { ActivityCreatePage } from './pages/ActivityCreatePage';
import { ActivityEditPage } from './pages/ActivityEditPage';
import { ActsListPage } from './pages/ActsListPage';
import { ActCreatePage } from './pages/ActCreatePage';
import { ActEditPage } from './pages/ActEditPage';
import { DocumentTemplatesPage } from './pages/DocumentTemplatesPage';
import { EmailTemplatesPage } from './pages/EmailTemplatesPage';
import { EmailLogsPage } from './pages/EmailLogsPage';
import { BookingJourneysPage } from './pages/BookingJourneysPage';
import { ClientActivityLogsPage } from './pages/ClientActivityLogsPage';
import { SmsSettingsPage } from './pages/SmsSettingsPage';
import { SmsLogsPage } from './pages/SmsLogsPage';
import { ClientUploadsPage } from './pages/ClientUploadsPage';
import { ContractsListPage } from './pages/ContractsListPage';
import { DocumentViewerPage } from './pages/DocumentViewerPage';
import { ProtectedRoute } from './components/ProtectedRoute';
import AdminOnlyRoute from './components/AdminOnlyRoute';
import PermissionRoute from './components/PermissionRoute';
import PractitionerOnlyRoute from './components/PractitionerOnlyRoute';
import { EmployeeOnlyRoute } from './components/EmployeeOnlyRoute';
import { DashboardEmployeePage } from './pages/DashboardEmployeePage';
import { Layout } from './components/Layout';
import { SessionExpiredModal } from './components/SessionExpiredModal';
import { sessionExpiredService } from './services/sessionExpiredService';
import { store } from './store';
import { logout } from './store/slices/authSlice';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PractitionerAppointmentsListPage from './pages/PractitionerAppointmentsListPage';
import PractitionerAppointmentCreatePage from './pages/PractitionerAppointmentCreatePage';
import PractitionerAppointmentViewPage from './pages/PractitionerAppointmentViewPage';
import PractitionerAppointmentEditPage from './pages/PractitionerAppointmentEditPage';
import DashboardPractitionerPage from './pages/DashboardPractitionerPage';
import { PractitionerMyProfilePage } from './pages/PractitionerMyProfilePage';
import PiercingDetailsPage from './pages/PiercingDetailsPage';
import PiercingContractPage from './pages/PiercingContractPage';
import PiercingCapturePage from './pages/PiercingCapturePage';
import PiercingFinalizationPage from './pages/PiercingFinalizationPage';
import ClientArrivalPage from './pages/ClientArrivalPage';
import { PiercingWorkflowProvider } from './contexts/PiercingWorkflowContext';
import { TasksListPage } from './pages/TasksListPage';
import { TaskFormPage } from './pages/TaskFormPage';
import { TestCasesListPage } from './pages/TestCasesListPage';
import { TestCaseInstancesListPage } from './pages/TestCaseInstancesListPage';
import { TestCaseFormPage } from './pages/TestCaseFormPage';
import { RbacSettingsPage } from './pages/RbacSettingsPage';
import { TestCaseDetailPage } from './pages/TestCaseDetailPage';
import { TestCaseInstanceFormPage } from './pages/TestCaseInstanceFormPage';
import { TestCaseInstanceDetailPage } from './pages/TestCaseInstanceDetailPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';

function App() {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const userType = useSelector((state: RootState) => (state.auth.user as any)?.userType) as
    | 'ADMIN'
    | 'PRACTITIONER'
    | 'EMPLOYEE'
    | undefined;
  const navigate = useNavigate();
  const [isSessionExpiredModalOpen, setIsSessionExpiredModalOpen] = useState(false);
  const [sessionExpiredMessage, setSessionExpiredMessage] = useState<string>();

  useEffect(() => {
    // Register callback with the service
    const unsubscribe = sessionExpiredService.onSessionExpired((message) => {
      setSessionExpiredMessage(message);
      setIsSessionExpiredModalOpen(true);
    });

    return unsubscribe;
  }, []);

  const handleSessionExpiredConfirm = () => {
    // Clear session
    store.dispatch(logout());
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    
    // Hide modal
    sessionExpiredService.hideSessionExpired();
    
    // Redirect to login
    navigate('/login');
  };

  const HomeRedirect = () => {
    if (userType === 'PRACTITIONER') return <Navigate to="/practitioner/dashboard" replace />;
    if (userType === 'EMPLOYEE')     return <Navigate to="/employee/dashboard" replace />;
    return <Navigate to="/dashboard" replace />;
  };

  return (
    <>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />}/>
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
        
        {/* Protected routes with layout */}
        <Route path="/" element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }>
          <Route index element={<HomeRedirect />} />

          {/* Practitioner area */}
          <Route path="practitioner/dashboard" element={<PractitionerOnlyRoute><DashboardPractitionerPage /></PractitionerOnlyRoute>} />
          <Route path="practitioner/appointments" element={<PractitionerOnlyRoute><PractitionerAppointmentsListPage /></PractitionerOnlyRoute>} />
          <Route path="practitioner/appointments/create" element={<PractitionerOnlyRoute><PractitionerAppointmentCreatePage /></PractitionerOnlyRoute>} />
          <Route path="practitioner/appointments/:id" element={<PractitionerOnlyRoute><PractitionerAppointmentViewPage /></PractitionerOnlyRoute>} />
          <Route path="practitioner/appointments/:id/edit" element={<PractitionerOnlyRoute><PractitionerAppointmentEditPage /></PractitionerOnlyRoute>} />

          {/* Piercing workflow wizard — single provider so step navigation keeps workflow state */}
          <Route path="practitioner/profile" element={<PractitionerOnlyRoute><PractitionerMyProfilePage /></PractitionerOnlyRoute>} />
          <Route
            path="practitioner/piercing/:appointmentId"
            element={
              <PractitionerOnlyRoute>
                <PiercingWorkflowProvider>
                  <Outlet />
                </PiercingWorkflowProvider>
              </PractitionerOnlyRoute>
            }
          >
            <Route path="details" element={<PiercingDetailsPage />} />
            <Route path="contract" element={<PiercingContractPage />} />
            <Route path="capture" element={<PiercingCapturePage />} />
            <Route path="finalization" element={<PiercingFinalizationPage />} />
          </Route>

          {/* Employee area */}
          <Route path="employee/dashboard" element={<EmployeeOnlyRoute><DashboardEmployeePage /></EmployeeOnlyRoute>} />

          {/* Employee arrival (admin accessible) */}
          <Route path="arrival" element={<AdminOnlyRoute><ClientArrivalPage /></AdminOnlyRoute>} />

          {/* Admin area */}
          <Route path="dashboard" element={<AdminOnlyRoute><DashboardPage /></AdminOnlyRoute>} />
          <Route path="quick-client-create" element={<AdminOnlyRoute><QuickClientCreatePage /></AdminOnlyRoute>} />
          <Route path="clients" element={<AdminOnlyRoute><ClientsListPage /></AdminOnlyRoute>} />
          <Route path="clients/create-full" element={<AdminOnlyRoute><ComprehensiveClientCreatePage /></AdminOnlyRoute>} />
          <Route path="clients/create-anonymous" element={<Navigate to="/appointments/create-anonymous" replace />} />
          <Route path="clients/:id/activity" element={<AdminOnlyRoute><ClientActivityLogsPage /></AdminOnlyRoute>} />
          <Route path="clients/:id/edit" element={<AdminOnlyRoute><ClientEditPage /></AdminOnlyRoute>} />
          <Route path="clients/:id" element={<AdminOnlyRoute><ClientViewPage /></AdminOnlyRoute>} />
          <Route path="appointments" element={<PermissionRoute permission="planning:read:shop"><AppointmentsListPage /></PermissionRoute>} />
          <Route path="appointments/create" element={<PermissionRoute permission="appointments:create"><AppointmentCreatePage /></PermissionRoute>} />
          <Route path="appointments/create-anonymous" element={<PermissionRoute permission="appointments:create"><AnonymousClientCreatePage /></PermissionRoute>} />
          <Route path="appointments/:id" element={<PermissionRoute permission="planning:read:shop"><AppointmentViewPage /></PermissionRoute>} />
          <Route path="appointments/:id/edit" element={<PermissionRoute permission="appointments:update"><AppointmentEditPage /></PermissionRoute>} />
          <Route path="practitioners" element={<AdminOnlyRoute><PractitionersListPage /></AdminOnlyRoute>} />
          <Route path="practitioners/create" element={<AdminOnlyRoute><PractitionerCreatePage /></AdminOnlyRoute>} />
          <Route path="practitioners/applications" element={<AdminOnlyRoute><PractitionerApplicationsPage /></AdminOnlyRoute>} />
          <Route path="practitioners/:id/edit" element={<AdminOnlyRoute><PractitionerEditPage /></AdminOnlyRoute>} />
          <Route path="practitioners/:id" element={<AdminOnlyRoute><PractitionerViewPage /></AdminOnlyRoute>} />
          <Route path="vendors" element={<AdminOnlyRoute><VendorsListPage /></AdminOnlyRoute>} />
          <Route path="vendors/create" element={<AdminOnlyRoute><VendorCreatePage /></AdminOnlyRoute>} />
          <Route path="vendors/:id/edit" element={<AdminOnlyRoute><VendorEditPage /></AdminOnlyRoute>} />
          <Route path="employees" element={<AdminOnlyRoute><EmployeesListPage /></AdminOnlyRoute>} />
          <Route path="employees/create" element={<AdminOnlyRoute><EmployeeCreatePage /></AdminOnlyRoute>} />
          <Route path="employees/:id/edit" element={<AdminOnlyRoute><EmployeeEditPage /></AdminOnlyRoute>} />
          <Route path="shops" element={<AdminOnlyRoute><ShopsListPage /></AdminOnlyRoute>} />
          <Route path="shops/create" element={<PermissionRoute permission="platform:shops:create"><ShopCreatePage /></PermissionRoute>} />
          <Route path="shops/:id/edit" element={<AdminOnlyRoute><ShopEditPage /></AdminOnlyRoute>} />
          <Route path="shops/:id" element={<AdminOnlyRoute><ShopViewPage /></AdminOnlyRoute>} />
          <Route path="services" element={<AdminOnlyRoute><ServicesListPage /></AdminOnlyRoute>} />
          <Route path="services/create" element={<AdminOnlyRoute><ServiceCreatePage /></AdminOnlyRoute>} />
          <Route path="services/:id/edit" element={<AdminOnlyRoute><ServiceEditPage /></AdminOnlyRoute>} />
          <Route path="services/:id" element={<AdminOnlyRoute><ServiceViewPage /></AdminOnlyRoute>} />
          <Route path="item-collections" element={<AdminOnlyRoute><ItemCollectionsListPage /></AdminOnlyRoute>} />
          <Route path="item-collections/:id/associations" element={<AdminOnlyRoute><ItemCollectionAssociationsPage /></AdminOnlyRoute>} />
          <Route path="body-zones" element={<AdminOnlyRoute><BodyZonesListPage /></AdminOnlyRoute>} />
          <Route path="piercing-types" element={<AdminOnlyRoute><PiercingTypesListPage /></AdminOnlyRoute>} />
          <Route path="planning/calendar" element={<PermissionRoute permission="planning:read:shop"><PlanningCalendarPage /></PermissionRoute>} />
          <Route path="planning/events" element={<PermissionRoute permission="planning:write:shop"><CalendarEventsPage /></PermissionRoute>} />
          <Route path="planning/rules" element={<PermissionRoute permission="schedule:configure:shop"><ScheduleRulesPage /></PermissionRoute>} />
          <Route path="planning/timeoffs" element={<PermissionRoute permission="time-off:manage:shop"><TimeOffManagerPage /></PermissionRoute>} />
          <Route path="planning/audit" element={<PermissionRoute permission="logs:read"><AuditLogsPage /></PermissionRoute>} />
          
          {/* Activity Management Routes */}
          <Route path="planning/activity-types" element={<AdminOnlyRoute><ActivityTypesListPage /></AdminOnlyRoute>} />
          <Route path="planning/activity-types/create" element={<AdminOnlyRoute><ActivityTypeCreatePage /></AdminOnlyRoute>} />
          <Route path="planning/activity-types/:id/edit" element={<AdminOnlyRoute><ActivityTypeEditPage /></AdminOnlyRoute>} />
          <Route path="planning/employee-activity-types" element={<AdminOnlyRoute><EmployeeActivityTypesListPage /></AdminOnlyRoute>} />
          <Route path="planning/employee-activity-types/create" element={<AdminOnlyRoute><EmployeeActivityTypeCreatePage /></AdminOnlyRoute>} />
          <Route path="planning/employee-activity-types/:id/edit" element={<AdminOnlyRoute><EmployeeActivityTypeEditPage /></AdminOnlyRoute>} />
          <Route path="planning/activities" element={<AdminOnlyRoute><ActivitiesListPage /></AdminOnlyRoute>} />
          <Route path="planning/activities/create" element={<AdminOnlyRoute><ActivityCreatePage /></AdminOnlyRoute>} />
          <Route path="planning/activities/:id/edit" element={<AdminOnlyRoute><ActivityEditPage /></AdminOnlyRoute>} />
          <Route path="planning/acts" element={<PermissionRoute permission="activities:manage:shop"><ActsListPage /></PermissionRoute>} />
          <Route path="planning/acts/create" element={<PermissionRoute permission="activities:manage:shop"><ActCreatePage /></PermissionRoute>} />
          <Route path="planning/acts/:id/edit" element={<PermissionRoute permission="activities:manage:shop"><ActEditPage /></PermissionRoute>} />

          {/* Task Management Routes */}
          <Route path="tasks" element={<AdminOnlyRoute><TasksListPage /></AdminOnlyRoute>} />
          <Route path="tasks/create" element={<AdminOnlyRoute><TaskFormPage /></AdminOnlyRoute>} />
          <Route path="tasks/:id/edit" element={<AdminOnlyRoute><TaskFormPage /></AdminOnlyRoute>} />

          {/* Test Case Management Routes (visible only when isTestMode=true) */}
          <Route path="test-cases" element={<AdminOnlyRoute><TestCasesListPage /></AdminOnlyRoute>} />
          <Route path="test-cases/create" element={<AdminOnlyRoute><TestCaseFormPage /></AdminOnlyRoute>} />
          <Route path="test-cases/:id" element={<AdminOnlyRoute><TestCaseDetailPage /></AdminOnlyRoute>} />
          <Route path="test-cases/:id/edit" element={<AdminOnlyRoute><TestCaseFormPage /></AdminOnlyRoute>} />
          <Route path="test-cases/:testCaseId/execute" element={<AdminOnlyRoute><TestCaseInstanceFormPage /></AdminOnlyRoute>} />
          <Route path="test-case-instances" element={<AdminOnlyRoute><TestCaseInstancesListPage /></AdminOnlyRoute>} />
          <Route path="test-case-instances/:id" element={<AdminOnlyRoute><TestCaseInstanceDetailPage /></AdminOnlyRoute>} />
          <Route path="test-case-instances/:instanceId/edit" element={<AdminOnlyRoute><TestCaseInstanceFormPage /></AdminOnlyRoute>} />

          {/* Company Management Routes */}
          <Route path="companies" element={<AdminOnlyRoute><CompaniesListPage /></AdminOnlyRoute>} />
          <Route path="companies/create" element={<PermissionRoute permission="platform:companies:write"><CompanyCreatePage /></PermissionRoute>} />
          <Route path="companies/:id" element={<AdminOnlyRoute><CompanyViewPage /></AdminOnlyRoute>} />
          <Route path="companies/:id/edit" element={<AdminOnlyRoute><CompanyEditPage /></AdminOnlyRoute>} />
          
          {/* Admin Management Routes */}
          <Route path="admins" element={<PermissionRoute permission="platform:admins:manage"><AdminsListPage /></PermissionRoute>} />
          <Route path="admins/create" element={<PermissionRoute permission="platform:admins:manage"><AdminCreatePage /></PermissionRoute>} />
          <Route path="admins/:id/edit" element={<AdminOnlyRoute><AdminEditPage /></AdminOnlyRoute>} />

          {/* User Management Routes (auth users) */}
          <Route path="users" element={<PermissionRoute permission="platform:users:manage"><UsersListPage /></PermissionRoute>} />
          <Route path="users/create" element={<PermissionRoute permission="platform:users:manage"><UserCreatePage /></PermissionRoute>} />
          <Route path="users/:id" element={<PermissionRoute permission="platform:users:manage"><UserViewPage /></PermissionRoute>} />
          <Route path="users/:id/edit" element={<PermissionRoute permission="platform:users:manage"><UserEditPage /></PermissionRoute>} />
          
          {/* Settings Routes */}
          <Route path="settings/general" element={<PermissionRoute permission="platform:settings"><GeneralParametersPage /></PermissionRoute>} />
          <Route path="settings/rbac" element={<PermissionRoute permission="platform:rbac:write"><RbacSettingsPage /></PermissionRoute>} />
          <Route path="settings/preferences" element={<AdminOnlyRoute><PreferencesPage /></AdminOnlyRoute>} />
          <Route path="settings/profile" element={<AdminOnlyRoute><ProfilePage /></AdminOnlyRoute>} />
          <Route path="settings/password" element={<AdminOnlyRoute><PasswordPage /></AdminOnlyRoute>} />
          <Route path="settings/email-templates" element={<AdminOnlyRoute><EmailTemplatesPage /></AdminOnlyRoute>} />
          <Route path="admin/email-logs" element={<PermissionRoute permission="logs:read"><EmailLogsPage /></PermissionRoute>} />
          <Route path="admin/booking-journeys" element={<PermissionRoute permission="logs:read"><BookingJourneysPage /></PermissionRoute>} />
          <Route path="admin/activity-logs" element={<PermissionRoute permission="logs:read"><ClientActivityLogsPage /></PermissionRoute>} />
          <Route path="settings/sms" element={<PermissionRoute permission="platform:settings"><SmsSettingsPage /></PermissionRoute>} />
          <Route path="admin/sms-logs" element={<PermissionRoute permission="logs:read"><SmsLogsPage /></PermissionRoute>} />
          <Route path="documents/templates" element={<AdminOnlyRoute><DocumentTemplatesPage /></AdminOnlyRoute>} />
          <Route path="documents/client-uploads" element={<AdminOnlyRoute><ClientUploadsPage /></AdminOnlyRoute>} />
          <Route path="documents/contracts" element={<AdminOnlyRoute><ContractsListPage /></AdminOnlyRoute>} />
          <Route path="documents/view/:id" element={<AdminOnlyRoute><DocumentViewerPage /></AdminOnlyRoute>} />
        </Route>

        {/* Catch all route */}
        <Route path="*" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />} />
      </Routes>

      {/* Session Expired Modal */}
      <SessionExpiredModal
        isOpen={isSessionExpiredModalOpen}
        message={sessionExpiredMessage}
        onClose={() => {
          setIsSessionExpiredModalOpen(false);
          sessionExpiredService.hideSessionExpired();
        }}
        onConfirm={handleSessionExpiredConfirm}
      />
    </>
  );
}

export default App;